import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-52" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-53" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-54" data-mp="32pp764lzrz6i">
          SIGMA SMART<span className="align-super text-xs" data-id="element-55" data-mp="36q92r3qx2uqj">™</span> — 100+ AI PROMPTS FOR THERAPISTS & COUNSELORS<span className="align-super text-xs" data-id="element-56" data-mp="3ug3gromz2pcd">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-57" data-mp="38h2z36jh6hs">
          “Finish your notes. Get your evenings back.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-58" data-mp="3le2jirrqo3ap">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-59" data-mp="3qfjhofiu9bnl">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-60" data-mp="2ezba1zojva52" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-61" data-mp="3lalhljipadw2">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-62" data-mp="3gc0ixoj3k29q" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-63" data-mp="3v919vptgrt75">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-64" data-mp="3q7bvc0718xeb">
            Terms & Conditions
          </a>
          <span data-id="element-65" data-mp="3474tnw649z9">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-66" data-mp="34p834h8zogo">
            Privacy Policy
          </a>
          <span data-id="element-67" data-mp="hsa8gqmqn9kw">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="huo3izhf4lsg">
            Support
          </a>
        </div>

        <p className="mt-6 text-[11px] leading-relaxed text-white/45" data-id="element-69" data-mp="qu1j89w4y6lm">
          An educational and productivity resource for licensed clinicians and supervised associates. It does not replace your clinical judgment, supervision, licensing board rules, payer requirements or privacy laws. Not for use by clients.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-70" data-mp="yruzmehxdfl5">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}